import _ from 'lodash';

const SHOW_FIELDS_TO = {
  NEW_ENTRANTS:   'entry.new',
  KNOWN_ENTRANTS: 'entry.existing',
  EVERYONE:       'entry.all',
};

const SHOW_FIELDS_TO_ALL = _.values(SHOW_FIELDS_TO);

const SHOW_FIELDS_TO_LIST_MACRO = [
  { text: 'New entrants', value: SHOW_FIELDS_TO.NEW_ENTRANTS },
  { text: 'Known entrants', value: SHOW_FIELDS_TO.KNOWN_ENTRANTS },
  { text: 'Everyone', value: SHOW_FIELDS_TO.EVERYONE },
];

const SHOW_FIELDS_TO_LIST_NEXTGEN = [
  { text: 'New participants', value: SHOW_FIELDS_TO.NEW_ENTRANTS },
  { text: 'Returning participants', value: SHOW_FIELDS_TO.KNOWN_ENTRANTS },
  { text: 'All participants', value: SHOW_FIELDS_TO.EVERYONE },
];

/**
 * Returns options list for 'show field to' dropdown based on whether if it's a NextGen designer or not
 */
const getFieldsToListByFormat = (isNextGenDesigner) =>
  isNextGenDesigner ? SHOW_FIELDS_TO_LIST_NEXTGEN : SHOW_FIELDS_TO_LIST_MACRO;

export { SHOW_FIELDS_TO, SHOW_FIELDS_TO_ALL, getFieldsToListByFormat };

export default SHOW_FIELDS_TO;
